import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, inject } from '@angular/core';

@Directive({
  selector: 'textarea[potAutoResize]',
  standalone: false,
})
export class PotTextareaAutoresizeDirective implements OnInit {
  public element: ElementRef = inject(ElementRef);

  @Input() public potAutoResize: boolean = false;
  @Output() public resized: EventEmitter<void> = new EventEmitter<void>();

  public ngOnInit(): void {
    if (this.potAutoResize) {
      setTimeout(() => this.adjust(), 0);
    }
  }

  @HostListener('input')
  public onInput(): void {
    if (this.potAutoResize) {
      this.adjust();
    }
  }

  public adjust(): void {
    const textArea: HTMLTextAreaElement = this.element.nativeElement;
    textArea.style.height = 'auto';
    textArea.style.height = `${textArea.scrollHeight}px`;
    this.resized.emit();
  }
}
